
 <div id="preloader">
	<div class="jumper">
		<div></div>
		<div></div>
		<div></div>
	</div>
</div>  
<!-- ***** Preloader End ***** -->

<!-- Header removed: global header is now provided by <app-header> -->

<div class="container contact">
  <div class="row">
    <div class="col-md-4 d-none d-md-block">
      <div class="contact-info text-center">
        <img src="https://image.ibb.co/kUASdV/contact-image.png" alt="image" class="img-fluid mb-3" />
        <h2>Join Carmotive CRM</h2>
        <p class="text-muted">Create an account to manage leads, inventory, and follow-ups in one premium CRM workspace.</p>
      </div>
    </div>

    <div class="col-md-8">
      <div class="card shadow-sm">
        <div class="card-body">
          <h4 class="card-title mb-3">Create an account</h4>

          <form [formGroup]="regForm" (ngSubmit)="registerUser()" novalidate>

            <div class="mb-3">
              <label class="form-label">Name</label>
              <input formControlName="name" class="form-control" [class.is-invalid]="regForm.get('name')?.invalid && regForm.get('name')?.touched" />
              <div *ngIf="regForm.get('name')?.errors && regForm.get('name')?.touched" class="invalid-feedback">
                <div *ngIf="regForm.get('name')?.errors?.required">Name is required</div>
                <div *ngIf="regForm.get('name')?.errors?.minlength">Name must be at least 2 characters</div>
              </div>
            </div>

            <div class="mb-3">
              <label class="form-label">Username</label>
              <input formControlName="username" class="form-control" [class.is-invalid]="regForm.get('username')?.invalid && regForm.get('username')?.touched" />
              <div *ngIf="regForm.get('username')?.errors && regForm.get('username')?.touched" class="invalid-feedback">
                <div *ngIf="regForm.get('username')?.errors?.required">Username is required</div>
                <div *ngIf="regForm.get('username')?.errors?.minlength">Username must be at least 3 characters</div>
              </div>
            </div>

            <div class="mb-3">
              <label class="form-label">Email</label>
              <input formControlName="email" class="form-control" [class.is-invalid]="regForm.get('email')?.invalid && regForm.get('email')?.touched" />
              <div *ngIf="regForm.get('email')?.errors && regForm.get('email')?.touched" class="invalid-feedback">
                <div *ngIf="regForm.get('email')?.errors?.required">Email is required</div>
                <div *ngIf="regForm.get('email')?.errors?.email">Enter a valid email</div>
              </div>
            </div>

            <div class="mb-3 row">
              <div class="col-md-6">
                <label class="form-label">Password</label>
                <input type="password" formControlName="password" class="form-control" [class.is-invalid]="regForm.get('password')?.invalid && regForm.get('password')?.touched" />
                <div *ngIf="regForm.get('password')?.errors && regForm.get('password')?.touched" class="invalid-feedback">
                  <div *ngIf="regForm.get('password')?.errors?.required">Password is required</div>
                  <div *ngIf="regForm.get('password')?.errors?.minlength">Password must be at least 6 characters</div>
                  <div *ngIf="regForm.get('password')?.errors?.pattern">Password must include letters and numbers</div>
                </div>
              </div>

              <div class="col-md-6">
                <label class="form-label">Confirm</label>
                <input type="password" formControlName="confirmPassword" class="form-control" [class.is-invalid]="(regForm.errors?.passwordMismatch) && regForm.get('confirmPassword')?.touched" />
                <div *ngIf="regForm.errors?.passwordMismatch && regForm.get('confirmPassword')?.touched" class="invalid-feedback">Passwords do not match</div>
              </div>
            </div>

            <div class="d-flex justify-content-between align-items-center">
              <div>
                <button class="btn btn-primary" [disabled]="regForm.invalid || submitting">
                  <span *ngIf="submitting" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Sign Up
                </button>
              </div>
              <div>
                <a [routerLink]="['/login']">Already have an account?</a>
              </div>
            </div>

            <div *ngIf="msg" class="alert alert-danger mt-3">{{ msg }}</div>
            <div *ngIf="successMsg" class="alert alert-success mt-3">{{ successMsg }}</div>

          </form>

        </div>
      </div>
    </div>
  </div>
</div>


